import React from 'react';

export function formatDate(epochSec) {
  if (!epochSec) return '';
  return new Date(epochSec * 1000).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function isAddressError(status) {
  return String(status || '').toUpperCase() === 'ADDRESS ERROR';
}

function titleCase(s) {
  return s ? s.charAt(0) + s.slice(1).toLowerCase() : s;
}

const ORDER_STATUS_COLORS = {
  SENT: { bg: 'var(--wi-status-good-10)', fg: 'var(--wi-status-good)' },
  DELIVERED: { bg: 'var(--wi-status-good-10)', fg: 'var(--wi-status-good)' },
  CREATED: { bg: 'var(--wi-status-info-10)', fg: 'var(--wi-status-info)' },
  CANCELLED: { bg: 'var(--wi-status-bad-10)', fg: 'var(--wi-status-bad)' },
  'ADDRESS ERROR': { bg: 'var(--wi-status-bad-10)', fg: 'var(--wi-status-bad)' },
  TRASHED: { bg: 'var(--wi-background-tertiary)', fg: 'var(--wi-text-secondary)' },
};

export default function OrderStatusBadge({ status }) {
  const s = String(status || '').toUpperCase();
  const c = ORDER_STATUS_COLORS[s] || { bg: 'var(--wi-background-tertiary)', fg: 'var(--wi-text-secondary)' };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', height: 22, padding: '0 10px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: c.bg, color: c.fg }}>
      {titleCase(s) || 'Unknown'}
    </span>
  );
}
